import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import { PollResponse, PollResponseList } from '../model/pollResponse.model';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MaterialService } from './material.service';
import { AuthenticationService } from './authentification.service';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PollResponseService extends KiwixiService {
    private apiUrl = environment.server + 'poll-responses/';


    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
        private authentificationService: AuthenticationService
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getPollResponses(params: HttpParams): Observable<PollResponseList> {
        const header = this.createHttpClientAuthorizationHeader();

        return this.http.get<PollResponseList>(this.apiUrl, {
            headers: header,
            params: params
        }).pipe(
            map(PollResponses => PollResponses),
            catchError(this.handleErrorObservable<PollResponseList>(`getObservablePollResponses`))
        );
    }

    getPollResponse(id: number): Observable<PollResponse> {
        const header = this.createHttpClientAuthorizationHeader();

        const url = `${this.apiUrl}${id}/`;
        return this.http.get<PollResponse>(url).pipe(
            catchError(this.handleErrorObservable<any>(`getPollResponse`))
        );;
    }

    postPollResponse(params: HttpParams): Observable<PollResponse> {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<PollResponse>(this.apiUrl, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<PollResponse>(`Création d'un PollResponse`)),
            );

    }

    patchPollResponse(url: string, params) {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<PollResponse>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<PollResponse>(`Patch d'un PollResponse`)),
            );
    }

    deletePollResponse(id: number): Observable<any> {
        const header = this.createHttpClientAuthorizationHeader();
        const url = `${this.apiUrl}${id}/`;
        return this.http.delete(url);
    }
}
